const e = {
  primary: {
    variant: "filled",
    $outlined: !1
  },
  secondary: {
    variant: "outlined",
    $outlined: !1
  },
  outlined: {
    variant: "outlined",
    $outlined: !0
  }
};
export {
  e as CHIP_VARIANT_MAPPING
};
//# sourceMappingURL=constants5.mjs.map
